import { render, staticRenderFns } from "./menu-sidebar.vue?vue&type=template&id=0f17c53a"
import script from "./menu-sidebar.vue?vue&type=script&lang=js"
export * from "./menu-sidebar.vue?vue&type=script&lang=js"
import style0 from "./menu-sidebar.vue?vue&type=style&index=0&id=0f17c53a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports